import { useSearchParams } from 'react-router-dom';
import { routes } from 'ogp/Routes';

type FlexpoolTab = 'internal' | 'external';

const { queryParams } = routes.FlexPools;

const updateTabSearchParams = (searchParams: URLSearchParams, tabId: FlexpoolTab) => {
  const nextParams = new URLSearchParams(searchParams);
  nextParams.set('tab', tabId);

  return nextParams;
};

export const useSelectedTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedExternalFlexpoolId = searchParams.get(queryParams.WORKERS_POOL_ID);
  const selectedTab: FlexpoolTab =
    searchParams.get('tab') === 'external' || selectedExternalFlexpoolId ? 'external' : 'internal';

  const handleTabChange = (_: unknown, tabId: unknown) => {
    if (tabId !== 'internal' && tabId !== 'external') {
      return;
    }

    setSearchParams(updateTabSearchParams(searchParams, tabId));
  };

  return { selectedTab, handleTabChange };
};
